import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/api";
import paths from "../utils/paths";

export const useTransferFacilities = ({
    agency_id,
    onSuccess,
    onError,
    enabled = false,
}) => {
    return useQuery({
        queryKey: ["transfer-facilities", agency_id],
        queryFn: async () => {
            const response = await axiosInstance.get(paths.transferFacilities(agency_id));
            return response.data;
        },
        onSuccess,
        onError,
        retry: false,
        enabled: enabled,
        staleTime: Infinity,
        gcTime: 0,
    });
};